module.exports = __webpack_public_path__ + "static/img/A143.e9238dc5.jpg";